'use client';
import React from 'react';
import ReactModal from 'react-modal';
import DeleteIcon from '@nerdwallet/react-icon/gizmo/Delete';
import styles from './legacy-modal.module.scss';

const containerClassMap = {
  small: styles.modalSizeSmall,
  medium: styles.modalSizeMedium,
  full: styles.modalSizeFull,
};

const getContainerClassName = (size, additionalClassName) =>
  [
    styles.modalBase,
    containerClassMap[size]
      ? containerClassMap[size]
      : containerClassMap.medium,
    additionalClassName,
  ].join(' ');

interface Props {
  size?: string;
  allowUserDismiss?: boolean;
  children?: React.ReactNode;
  useWhiteCloseButton?: boolean;
  additionalClassName?: string;
  onAttemptDismiss: () => void;
}

const LegacyModal = ({
  size,
  children,
  onAttemptDismiss,
  additionalClassName,
  allowUserDismiss = false,
  useWhiteCloseButton,
}: Props) => (
  <ReactModal
    isOpen
    onRequestClose={allowUserDismiss ? onAttemptDismiss : null}
    className={{
      base: getContainerClassName(size, additionalClassName),
      afterOpen: styles.modalAfterOpen,
      beforeClose: styles.modalAfterClose,
    }}
    overlayClassName={styles.overlay}
    contentLabel="Modal"
    ariaHideApp={false}
  >
    {allowUserDismiss && (
      <DeleteIcon
        className={
          useWhiteCloseButton ? styles.whiteCloseButton : styles.closeButton
        }
        onClick={onAttemptDismiss}
      />
    )}
    {children}
  </ReactModal>
);

export default LegacyModal;
